// @flow
import React from 'react';
import { SortDirection } from 'react-virtualized';

import type { User } from 'state/types';
import { roleOrder } from './roleUtils';
import {
  isItemAtIndexSelected,
  type SelectionState,
  type SortDirectionType,
} from 'util/tableUtils';
import { ADMIN_USER_NAME, CATALOG_STATUS } from 'util/constants';

function sortUsers(
  users: User[],
  sortBy: string,
  sortDirection: SortDirectionType
): User[] {
  const sorted: User[] = users.sort((a, b) => {
    const aVal = a[sortBy];
    const bVal = b[sortBy];

    const isOnline = userStatus => userStatus === CATALOG_STATUS.ONLINE;

    if (sortBy === 'userStatus') {
      return aVal === bVal
        ? a.name.localeCompare(b.name)
        : isOnline(aVal)
        ? -1
        : isOnline(bVal)
        ? 1
        : a.name.localeCompare(b.name);
    }

    if (sortBy === 'roleName') {
      const sortOrder = roleOrder(aVal) - roleOrder(bVal);
      return sortOrder === 0 ? a.name.localeCompare(b.name) : sortOrder;
    }

    if (typeof aVal === 'boolean') {
      return aVal === bVal ? a.name.localeCompare(b.name) : aVal ? -1 : 1;
    }

    if (!aVal && !bVal) {
      return a.name.localeCompare(b.name);
    } else if (!aVal) {
      return 1;
    } else if (!bVal) {
      return -1;
    }

    return aVal.localeCompare(bVal);
  });

  return sortDirection === SortDirection.ASC ? sorted : sorted.reverse();
}

function isAdminUser(user: User) {
  return user.name === ADMIN_USER_NAME;
}

function doesUserMatchUserName(user: User, userName: string) {
  return userName && userName.toLowerCase() === user.name.toLowerCase();
}

function renderUserType(
  rowData: Object,
  rowIndex: number,
  selectionState: SelectionState
) {
  const selectionContribution = isItemAtIndexSelected(rowIndex, selectionState)
    ? '-selected'
    : '';
  if (rowData.fromLDAP) {
    return (
      <i
        className={'fa fa-refresh pseudo-table-icon' + selectionContribution}
        data-test-name="user-type-ldap"
      />
    );
    // We can enable support for token icons but we'll
    // need to support sorting them with the users and LDAP users.
    // } else if (rowData.isToken) {
    //   return <i className="fa fa-cogs pseudo-table-icon" />;
  }

  return (
    <i
      className={'fa fa-user fa-lg pseudo-table-icon' + selectionContribution}
      data-test-name="user-type-portfolio"
    />
  );
}

function findUserIndex(uuid?: string, sortedUsers: User[]) {
  let selectedIndex;
  if (uuid) {
    selectedIndex = sortedUsers.findIndex(u => u.uuid === uuid);
  }

  return selectedIndex;
}

export {
  doesUserMatchUserName,
  findUserIndex,
  isAdminUser,
  sortUsers,
  renderUserType,
};



// WEBPACK FOOTER //
// ./src/util/userUtils.js